export default __webpack_public_path__ + "static/media/edit.5ae5f83d.svg";